import { render, staticRenderFns } from "./VendorComment.vue?vue&type=template&id=4efbffda&scoped=true&"
import script from "./VendorComment.vue?vue&type=script&lang=js&"
export * from "./VendorComment.vue?vue&type=script&lang=js&"
import style0 from "./VendorComment.vue?vue&type=style&index=0&id=4efbffda&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4efbffda",
  null
  
)

export default component.exports